import React, { useMemo } from "react";

import { getTextColor } from "components/dashboard/charts/utils";
import { useTimezone } from "hooks/useTimezone";
import useDashboardStore from "store/dashboard-store";
import { useUserState } from "store/user-store";
import { replaceVariables, VariableReplacementContext } from "utils/variable-replacer";
import "./FreeText.scss";
import { FreeTextConfig } from "./FreeTextConfig";

export default function FreeText(props: FreeTextConfig) {
  const dashboard = useDashboardStore(state => state.dashboard);
  const tz = useTimezone();
  const locale = useUserState(state => state.getLanguage());

  const rawHtml = props.useHTMLCode ? (props.htmlContent ?? "") : (props.content ?? "");

  const context: VariableReplacementContext = useMemo(
    () => ({
      dashboard,
      referenceTime: props.referenceTime,
      instantReferenceTime: props.instantReferenceTime,
      zoneId: tz.company,
      localDateVariables: props.variables,
    }),
    [dashboard, props.referenceTime, props.instantReferenceTime, tz.company, props.variables]
  );

  const processedHtml = useMemo(() => {
    return replaceVariables(rawHtml, context, tz.display, locale);
  }, [rawHtml, context, tz.display, locale]);

  return (
    <div className="quill-rendered-content" style={{ height: `${props.height ?? "auto"}px` }}>
      <div
        style={{ color: getTextColor(props.theme) }}
        dangerouslySetInnerHTML={{
          __html: processedHtml,
        }}
      />
    </div>
  );
}
